import { render, staticRenderFns } from "./OpportunityAddStartup.vue?vue&type=template&id=8bc8c5cc&scoped=true&"
import script from "./OpportunityAddStartup.vue?vue&type=script&setup=true&lang=js&"
export * from "./OpportunityAddStartup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc8c5cc",
  null
  
)

export default component.exports